var map = {
	"./C-40-download_2x_1.png": 909,
	"./avatar-awaiting.png": 910,
	"./docs.png": 911,
	"./locket.png": 912
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 908;


//////////////////
// WEBPACK FOOTER
// ./src/client/images ^\.\/.*$
// module id = 908
// module chunks = 1